function layoutSwitcher() {
  Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(link => {
    link.addEventListener('click', toggle);
    link.addEventListener('keydown', handleKeyDown);
  });
};
function handleKeyDown(event){
  if (event.keyCode === 13) {
    toggle(event);
  }
}
function toggle(event){
  Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(e => e.classList.remove('active'));
  event.currentTarget.classList.add('active');
  if(event.currentTarget.classList.contains('listv')){
    document.getElementById('ProductGridContainer').classList.add('product-list');
    document.getElementById('ProductGridContainer').classList.remove('product-grid');
    document.getElementById('ProductGridContainer').classList.remove('product-gallery');
    // Remove 'active' class from gridv on mobile
    if (window.innerWidth < 992) { 
       document.querySelector(".gridv").classList.remove('active_mobile'); 
    }
  }else if(event.currentTarget.classList.contains('gridv')){
    document.getElementById('ProductGridContainer').classList.add('product-grid');
    document.getElementById('ProductGridContainer').classList.remove('product-list');
    document.getElementById('product-grid').classList.remove('product-list');
    document.getElementById('ProductGridContainer').classList.remove('product-gallery');
  }else if(this.classList.contains('galleryv')){
      document.getElementById('ProductGridContainer').classList.add('product-gallery');
      document.getElementById('ProductGridContainer').classList.remove('product-list');
      document.getElementById('product-grid').classList.remove('product-list');
      document.getElementById('ProductGridContainer').classList.remove('product-grid');
  }
}
document.addEventListener("shopify:section:load", layoutSwitcher);
layoutSwitcher();


// on scroll play video
window.addEventListener('load', videoScroll);
window.addEventListener('scroll', videoScroll);
function videoScroll() {
  if ( document.querySelectorAll('video[autoplay]').length > 0) {
    var windowHeight = window.innerHeight, videoEl = document.querySelectorAll('video[autoplay]');
    for (var i = 0; i < videoEl.length; i++) {
      var thisVideoEl = videoEl[i],
          videoHeight = thisVideoEl.clientHeight,
          videoClientRect = thisVideoEl.getBoundingClientRect().top;
      if ( videoClientRect <= ( (windowHeight) - (videoHeight*.5) ) && videoClientRect >= ( 0 - ( videoHeight*.5 ) ) ) {
        thisVideoEl.play();
      } else {
        thisVideoEl.pause();
      }
    }
  }
}

// timer
setInterval(countDown, 1000);
function countDown() {
  const countCardSections = document.querySelectorAll('.countd_all');
  countCardSections.forEach((countdownSection) => {
    var countDownDate = new Date(countdownSection.getAttribute('data-date').replaceAll('-','/')).getTime();
    var now = new Date().getTime();
    var distance = countDownDate - now;
    if (distance < 0 || isNaN(countDownDate)) {
      countdownSection.querySelector('.main_cdays .wb_cdays').textContent = "00";
      countdownSection.querySelector('.main_chours .wb_chours').textContent = "00";
      countdownSection.querySelector('.main_cminutes .wb_cminutes').textContent = "00";
      countdownSection.querySelector('.main_cseconds .wb_cseconds').textContent = "00";
    }
    else {
      countdownSection.querySelector('.main_cdays .wb_cdays').textContent = Math.floor(distance / (1000 * 60 * 60 * 24));
      countdownSection.querySelector('.main_chours .wb_chours').textContent = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      countdownSection.querySelector('.main_cminutes .wb_cminutes').textContent = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      countdownSection.querySelector('.main_cseconds .wb_cseconds').textContent = Math.floor((distance % (1000 * 60)) / 1000);
    }
  });
}

/* ==========================================================================
   ATN Audio — one-line spec under each product card title (added 03/09/2026)
   Data comes from the product's own Shopify tags (room-*, subcategory:*) and
   its own description. To change a line, edit the SPECS map below.
   To roll back completely, delete this block.
   ========================================================================== */
(function () {
  var SYS = ' · amp + speakers + 2 mics';
  var SPECS = {
    'atn-dk-750-amplifier-ampyon-ksx-10-karaoke-speakers': 'Small rooms' + SYS,
    'atn-dk-750-amplifier-ampyon-ls-10-speakers': 'Small rooms' + SYS,
    'dk-750-amplifier-ampyon-ls-10ex-speakers': 'Medium rooms' + SYS,
    'pro-750-amplifier-ampyon-ls-12ex-speakers': 'Medium rooms' + SYS,
    'combo-h-450-amplifier-ampyon-ls-12ex-speakers': 'Medium rooms' + SYS,
    'amply-dk-750-bose-l1-pro-8': 'Medium rooms' + SYS,
    'amply-pro-750-bose-l1-pro-8': 'Medium rooms' + SYS,
    'amply-h-450-bose-l1-pro-8': 'Medium rooms' + SYS,
    'amply-dk-750-bose-l1-pro-16': 'Large rooms & parties' + SYS,
    'amply-pro-750-bose-l1-pro-16': 'Large rooms & parties' + SYS,
    'amply-h-450-bose-l1-pro-16': 'Large rooms & parties' + SYS,
    'amply-dk-750-qsc-kc12': 'Large rooms & parties' + SYS,
    'amply-h-450-qsc-kc12': 'Large rooms & parties' + SYS,
    'amply-pro-750-qsc-kc12': 'Large rooms & parties' + SYS,
    'amply-dk-750-bose-l1-pro-32-with-sub': 'Professional venues' + SYS,
    'amply-pro-750-bose-l1-pro-32-with-sub': 'Professional venues' + SYS,
    'amply-h-450-bose-l1-pro-32-with-sub': 'Professional venues' + SYS,
    'dk-750-karaoke-amplifier': 'Karaoke mixing amplifier',
    'h-450-karaoke-amplifier': 'Karaoke mixing amplifier',
    'pro-750-karaoke-amplifier': 'Karaoke mixing amplifier',
    'ampyon-elite-es-3000': 'Passive · 1000W per pair · needs an amplifier',
    'ampyon-ksx-10-karaoke-speaker': 'Passive · needs an amplifier',
    'ampyon-ls-10-professional-karaoke-speaker': 'Passive · needs an amplifier',
    'ampyon-ls-10ex-professional-karaoke-speaker': 'Passive · needs an amplifier',
    'ampyon-ls-12es-professional-karaoke-speaker': 'Passive · needs an amplifier',
    'ampyon-ls-12ex-professional-karaoke-speaker': 'Passive · needs an amplifier',
    'ampyon-starbox-iii-portable-karaoke-speaker': 'All-in-one portable · 2 wireless mics included',
    'ampyon-li-1000-uhf-wireless-microphone': 'UHF wireless microphone system',
    'bose-s1-pro-plus-portable-bluetooth-speaker-system': 'Powered · built-in amplifier',
    'l1-pro8-portable-line-array-system': 'Powered · built-in amplifier',
    'l1-pro16-portable-line-array-system': 'Powered · built-in amplifier',
    'l1-pro32-portable-line-array-system-with-sub2-powered-bass-module': 'Powered · built-in amplifier',
    'qsc-kc12-column-pa-system-black': 'Powered · built-in amplifier',
    'qsc-kc12-column-pa-system-white': 'Powered · built-in amplifier',
    'qsc-cb10-powered-pa-speaker-with-battery': 'Powered · built-in amplifier',
    'jbl-partybox-720': 'Powered · mic input',
    'jbl-partybox-club-120': 'Powered · mic input',
    'jbl-partybox-encore': 'Powered · mic input',
    'bose-soundlink-revolve-ii': 'Bluetooth speaker · no mic input',
    'bose-soundlink-flex-2nd-gen': 'Bluetooth speaker · no mic input',
    'bose-soundlink-micro': 'Bluetooth speaker · no mic input',
    'jbl-xtreme-4': 'Bluetooth speaker · no mic input',
    'jbl-charge-5': 'Bluetooth speaker · no mic input',
    'jbl-flip-6': 'Bluetooth speaker · no mic input',
    'jbl-go-4': 'Bluetooth speaker · no mic input',
    'jbl-horizon-2': 'Bluetooth speaker · no mic input',
    'harman-kardon-onyx-studio-8': 'Bluetooth speaker · no mic input',
    'marshall-acton-iii': 'Bluetooth speaker · no mic input'
  };

  function injectStyle() {
    if (document.getElementById('atn-card-spec-style')) return;
    var s = document.createElement('style');
    s.id = 'atn-card-spec-style';
    s.textContent = '.atn-card-spec{font-size:12px;line-height:1.35;opacity:.62;margin:1px 0 5px;letter-spacing:.1px}';
    (document.head || document.documentElement).appendChild(s);
  }

  function apply() {
    var infos = document.querySelectorAll('.card__information');
    for (var i = 0; i < infos.length; i++) {
      var info = infos[i];
      if (info.querySelector('.atn-card-spec')) continue;
      var link = info.querySelector('a[href*="/products/"]');
      if (!link) continue;
      var m = (link.getAttribute('href') || '').match(/\/products\/([^?#\/]+)/);
      if (!m) continue;
      var spec = SPECS[m[1]];
      if (!spec) continue;
      var heading = info.querySelector('.card__heading');
      if (!heading) continue;
      var el = document.createElement('div');
      el.className = 'atn-card-spec';
      el.textContent = spec;
      heading.insertAdjacentElement('afterend', el);
    }
  }

  function run() { injectStyle(); apply(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);

  if (window.MutationObserver) {
    var scheduled = false;
    var mo = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      setTimeout(function () { scheduled = false; apply(); }, 80);
    });
    var start = function () { if (document.body) mo.observe(document.body, { childList: true, subtree: true }); };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  }
})();
